import { fetchWithSupabaseAuth } from "./supabaseClient.js";

async function request(path, options = {}) {
  const response = await fetchWithSupabaseAuth(`/api/local-tools${path}`, {
    cache: "no-store",
    ...options,
    headers: { Accept: "application/json", "Content-Type": "application/json", ...options.headers },
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(typeof payload?.detail === "string" ? payload.detail : "Les outils locaux sont indisponibles.");
    error.status = response.status;
    throw error;
  }
  return payload;
}

export const fetchLocalTools = () => request("");
export const previewCacheTransfer = (direction) => request("/cache-transfers/preview", {
  method: "POST", body: JSON.stringify({ direction }),
});
export const fetchCacheTransfer = (id) => request(`/cache-transfers/${encodeURIComponent(id)}`);
export const confirmCacheTransfer = (id) => request(`/cache-transfers/${encodeURIComponent(id)}/confirm`, { method: "POST" });
